import { createFeatureSelector, createSelector } from '@ngrx/store';
import { coreFeatureName, CoreState } from './core.reducer';

export const selectCoreState = createFeatureSelector<CoreState>(coreFeatureName);

export const selectIdentityState = createSelector(
  selectCoreState,
  (state: CoreState) => state.identity
);
